import { useEffect, useState } from 'react'
import { useAdobeAnalytics } from './useAdobeAnalytics'
import { trackClickEvent, trackImpressionEvent } from '@utils/analytics'

export const trackingEventTypes = {
  IMPRESSION_EVENT: 'impressionevent',
  CLICK_EVENT: 'clickevent',
}

const functionToCall = (trackingEvent, data) => {
  switch (trackingEvent) {
    case trackingEventTypes.IMPRESSION_EVENT:
      return () => {
        trackImpressionEvent(data)
      }
    case trackingEventTypes.CLICK_EVENT:
      return () => {
        trackClickEvent(data)
      }
    default:
      return () => {}
  }
}

export const useAdobeAnalyticsEventQueue = () => {
  const isSdkReady = useAdobeAnalytics()
  const [queue, setQueue] = useState([])

  useEffect(() => {
    if (isSdkReady && queue?.length > 0) {
      queue?.forEach((functionToCall) => {
        if (typeof functionToCall === 'function') {
          functionToCall()
        }
      })
      setQueue([])
    }
  }, [isSdkReady])

  const addTrackingEvent = (trackingEvent = '', data = {}) => {
    if (isSdkReady) {
      functionToCall(trackingEvent, data)()
    } else {
      setQueue([...queue, functionToCall(trackingEvent, data)])
    }
  }

  return { addTrackingEvent }
}
